import HttpService from '../baseHttp'


// b2c订单列表接口
export const HttpB2cList = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpB2cExport = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/exportXlsx', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// b2c订单查看和编辑
export const HttpqueryB2COrder = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpSaveOne = (data = {}, config) => HttpService.post('/api/v2/B2cOrder/saveOne', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
// 取消订单、重置订单、恢复正常、添加备注、重新提交
export const HttpCancelOrder = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/cancelOrder', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpResetOrder = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/resetOrder', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpRecoveryNormal = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/recoveryNormal', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpAddRemark = (data = {}, config) => HttpService.post('/api/v2/B2cOrder/addRemark', data)
export const HttpbatchCancel = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/batchCancelUnshipped', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpResubmit = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/reSubmit', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
//
// 项目手动关联、审核通过

export const HttptoExamine = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/toExamine', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 激活订单、推送云仓、成本获利、批量修改 （订单列表）
export const HttpActiveOrder = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/activateOrder', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpPushFbb = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/pushFbb', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpComuteCosts = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/computeCosts', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpChangeOrder = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/changeOrderType', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpAddorderSign = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/addOrderSign', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 批量下载面单按钮
export const HttpDownSurFaceOrder = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/download', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 子单据取消查询是否有兄弟子单据
export const HttpCheckOtherOrder = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/containOthersubOrder', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })



// 修改仓库物流 提交异常
export const HttpsSaveLogistics = (data = {}, config) => HttpService.post('/api/v2/B2cOrder/saveLogistics', data)
export const HttpSubmitError = (data = {}, config) => HttpService.post('/api/v2/B2cOrder/submitError', data)
// 查询条件导出
export const HttpExportXlsx = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/exportXlsx', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 查询库存
export const HttpFindByPage = (data = {}, config) => HttpService.get('/api/v2/inventory/findByPageInOrder', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 提交添加礼品单
export const HttpsaveAdditional = (data = {}, config) => HttpService.post('/api/v2/B2cOrder/saveAdditional', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
// 批量修改 手动关闭
export const HttpCloseOrder = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/closeOrder', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpMfnManuallyCheck = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/mfnManuallyCheck', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 邀请评论
export const HttpInviteComment = (data = {}, config) => HttpService.post('/api/v2/B2cOrder/inviteComments', data)

// 拆解订单、附件上传(请求、删除)
export const HttpdismantlingOrderRead = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/dismantlingOrderRead', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HtttdismantlingOrder = (data = {}, config) => HttpService.post('/api/v2/B2cOrder/dismantlingOrder', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HtttrackingReturn = (data = {}, config) => HttpService.post('/api/v2/B2cOrder/trackingReturn', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpfindAnnexByOrderId = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/findAnnexByOrderId', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpDelAnnex = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/delAnnex', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 强制手动回传
export const HttpforceTrackingReturn = (data = {}, config) => HttpService.post('/api/v2/B2cOrder/forceTtrackingReturn', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 国家、省份/州
export const HttpGetContry = (data = {}, config) => HttpService.get('/api/v1/countryInfo/getCountry', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpGetStates = (data = {}, config) => HttpService.get('/api/v1/commonRegion/getCommonRegion', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 仓库发运方式查询
export const HttpFindWarehouseCarriers = (data = {}, config) => HttpService.get('/api/v2/warehouse/findWarehouseCarriers', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
// 包含卡车的发运方式
export const HttpFindTruckWarehouseCarriers = (data = {}, config) => HttpService.get('/api/v2/carrierVolumeWeight/findByContextIdAndWarehouseCode', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })



// b2c异常订单列表接口
export const HttpB2cErrorList = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/findByErrorPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// b2c所有异常订单列表接口
export const HttpB2cAllErrorList = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/findByAllErrorPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// b2c待发货列表接口
export const HttpB2cAllUnshippedList = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/findByAllUnshipped', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// b2c订单管理端列表接口
export const HttpB2cAdminList = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/findByAdminPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
//自动拆单
export const HttpB2cDisassembly = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/orderDistributionDisassembly', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
//获取虚拟库存
export const HttpB2cgetVirtualInventoryDetail = (data = {}, config) => HttpService.get('/api/v2/StockGroupInventory/getVirtualInventoryDetail', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 获取tab数据条目
export const HttpGetTabNumber = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/orderCount', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 获取新接口
export const HttpGetSystemDeliveryCarriers = (data = {}) => HttpService.get('/api/v2/SystemDeliveryCarrier/selectSystemDeliveryCarriers', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB})
// 获取承运商（全部、有效）
export const HttpAllGetService = (data = {}) => HttpService.get('/api/v2/carrierVolumeWeight/bossFindAllByContextId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpActiveGetService = (data = {}) => HttpService.get('/api/v2/carrierVolumeWeight/bossFindByContextId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
// 新接口
export const HttpNewActiveGetService = (data = {}) => HttpService.get('/api/v2/carrierGroupServiceCode/bossFindByCustomerId', { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP })

// 修改最晚发货时间
export const HttpChangeLastestTime = (data = {}) => HttpService.get('/api/v2/B2cOrder/updateLatestShipDate', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 修改发货方式
export const HttpSwitchIssueMethod = (data = {}) => HttpService.get('/api/v2/B2cOrder/changeOutboundModel', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 查询所有标签
export const HttpGetAllLabel = (data = {}) => HttpService.get('/api/v1/CommonModuleLabel/findAllByOrgIdAndModule', { params: data })
// 标签保存
export const HttpSaveLabel = (data = {}, config) => HttpService.post('/api/v1/CommonModuleLabel/save', data, { headers: { "Content-Type": "application/json" } })
// 单据添加标签
export const HttpOrderAddLabel = (data = {}) => HttpService.get('/api/v2/B2cOrder/addLabel', { params: data })
// 单据移除标签
export const HttpOrderRemoveLabel = (data = {}) => HttpService.get('/api/v2/B2cOrder/removeLabel', { params: data })
// 查询收藏
export const HttpGetSearchCollect = (data = {}) => HttpService.get('/api/v1/SearchCollect/findListByUser', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 添加收藏
export const HttpAddSearchCollect = (data = {}, config) => HttpService.post('/api/v1/SearchCollect/save', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_UC } )
// 删除收藏
export const HttpDeleteSearchCollect = (data = {}) => HttpService.get('/api/v1/SearchCollect/batchDelete', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 按id查找收藏
export const HttpGetSearchCollectById = (data = {}) => HttpService.get('/api/v1/SearchCollect/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })



// 订单拆分
// 查询、保存
export const HttpGetOrderSplit = (data = {}, config) => HttpService.get('/api/v2/saleorderconf/findAll', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttSaveOrderSplit = (data = {}, config) => HttpService.post('/api/v2/saleorderconf/saveAll', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })


// 新增发运方式的下拉  管理端查询/客户端
export const HttpGetCarrierCusList = (data = {}, config) => HttpService.get('/api/v2/carrierGroup/findByOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpDownAmxl = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/downloadAmxl', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 获取预估费用
export const HttpGetCalculateCost = (data = {}) => HttpService.get('/api/v2/B2cOrder/getCalculateItemDate', { params: data });
// 拦截
export const HttpIntercept = (data = {}) => HttpService.get('/api/v2/B2cOrder/intercept', { params: data });


// tracking提前回传
export const HttpTrackingComeback = (data = {}) => HttpService.get('/api/v2/B2cOrder/fastship', { params: data });

//获取换货明细
export const HttpGetAmaReplacementDetails = (data = {}, config) => HttpService.get('/api/v2/B2cOrder/getAmaReplacementDetails', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })


// 替换旧的查询 组织下所有 物流产品服务code
export const HttpGetAllCustomerIdCode = (data = {}) => HttpService.get('/api/v2/carrierGroupServiceCode/bossFindByCustomerId', { params: {customerId:global.SYSID,...data}, baseURL: process.env.VUE_APP_APIURL_SHIP })

// 替换旧的根据 组织和仓库 查询物流产品服务code
export const HttpGetOrgWarehouseCode = (data = {}) => HttpService.get('/api/v2/carrierGroupServiceCode/bossFindByOrgIdAndWarehouseCode', { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP })

// 订单列表查询运单信息
export const HttpLabelDifferenceDetail = (data = {}) => HttpService.get('/api/jwt/spl/shippinginfo/queryByTrackingNo', { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP })



